import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { applyTheme, loadTheme } from './lib/dark-mode';
import 'maplibre-gl/dist/maplibre-gl.css';
import './styles/global.css';

// Apply the saved/preferred theme synchronously, before the first render —
// avoids the "flash of light theme" when the user has dark mode set.
applyTheme(loadTheme());

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element #root not found in index.html');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
